<template>
  <div class="h-screen pb-safe flex flex-col overflow-hidden">
    <top-bar-desktop v-if="!isMobile">
      <template #left>
        <div></div>
      </template>
      <template #center>
        <span class="font-heading font-bold text-xl">
          {{ title }}
        </span>
      </template>
      <template #right>
        <l-button
          v-if="showClose"
          size="medium"
          icon="close"
          type="text"
          color="white"
          @click="$emit('close')"
        />
        <span v-else><!-- Added to prevent to show default slot content--></span>
      </template>
    </top-bar-desktop>
    <top-bar-mobile
      v-else
      :show-close="showClose"
      :show-back="showBack"
      @close="$emit('close')"
      @back="$emit('back')"
    >
      <template #[mobileSlot]>
        <span class="font-heading font-bold text-xl">
          {{ title }}
        </span>
      </template>
    </top-bar-mobile>
    <div class="overflow-y-scroll scrolling-touch w-full h-full bg-n-800 relative">
      <slot />
    </div>
    <div v-if="$slots.footer" class="p-4 pb-7 flex justify-center">
      <slot name="footer" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'
import { computed } from 'vue'

import { LButton } from '@last/core-ui/paprika'

import TopBarDesktop from './TopBar.vue'
import TopBarMobile from './TopBarMobile.vue'

const props = withDefaults(
  defineProps<{
    title: string
    showBack?: boolean
    showClose?: boolean
  }>(),
  {
    showBack: false,
    showClose: true
  }
)

defineEmits<{
  close: []
  back: []
}>()

const mobileSlot = computed(() => (props.showBack ? 'center' : 'left'))

const isMobile = useBreakpoints(breakpointsTailwind).smallerOrEqual('sm')
</script>
